/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer } from "ethers";
import { Provider } from "@ethersproject/providers";

export class ShyftFactory {
  static connect(address: string, signerOrProvider: Signer | Provider) {
    return new Contract(address, _abi, signerOrProvider);
  }
}

const _abi = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "_nativeBip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        type: "address",
        name: "tokenOwner",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "spender",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "tokens",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_ApprovalBip32X",
    inputs: [
      {
        type: "address",
        name: "tokenOwner",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "spender",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "tokens",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "bip32X_type",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_Erc223TokenFallback",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "bytes",
        name: "_data",
        internalType: "bytes",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_TransferAndBurnBip32X",
    inputs: [
      {
        type: "address",
        name: "contractAddress",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "msgSender",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "to",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "value",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "bip32X_type",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_TransferAndMintBip32X",
    inputs: [
      {
        type: "address",
        name: "contractAddress",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "msgSender",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "value",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "bip32X_type",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_TransferBip32X",
    inputs: [
      {
        type: "address",
        name: "from",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "to",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "tokens",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "bip32X_type",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_UpgradeFromV1",
    inputs: [
      {
        type: "address",
        name: "_originAddress",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "_userAddress",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_WithdrawToAddress",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_WithdrawToExternalContract",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_WithdrawToShyftKycContract",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
        indexed: false,
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
        indexed: false,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_migrateFromContract",
    inputs: [
      {
        type: "address",
        name: "sendingKycContract",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "totalSupplyBip32X",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "msgValue",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "uint256",
        name: "thisBalance",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_migrateToKycContract",
    inputs: [
      {
        type: "address",
        name: "updatedShyftKycContractAddress",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "updatedContractBalance",
        internalType: "uint256",
        indexed: false,
      },
      {
        type: "address",
        name: "kycContractAddress",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "to",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_receivedNativeBalance",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_redeemIncorrectlySentAsset",
    inputs: [
      {
        type: "address",
        name: "_destination",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EVT_setV1EmergencyResponder",
    inputs: [
      {
        type: "address",
        name: "_emergencyResponder",
        internalType: "address",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleAdminChanged",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
        indexed: true,
      },
      {
        type: "bytes32",
        name: "previousAdminRole",
        internalType: "bytes32",
        indexed: true,
      },
      {
        type: "bytes32",
        name: "newAdminRole",
        internalType: "bytes32",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleGranted",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
        indexed: true,
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "sender",
        internalType: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleRevoked",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
        indexed: true,
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "sender",
        internalType: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        type: "address",
        name: "from",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "to",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "tokens",
        internalType: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bytes32",
        name: "",
        internalType: "bytes32",
      },
    ],
    name: "DEFAULT_ADMIN_ROLE",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bytes32",
        name: "",
        internalType: "bytes32",
      },
    ],
    name: "MINTER_ROLE",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "remaining",
        internalType: "uint256",
      },
    ],
    name: "allowance",
    inputs: [
      {
        type: "address",
        name: "_tokenOwner",
        internalType: "address",
      },
      {
        type: "address",
        name: "_spender",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "remaining",
        internalType: "uint256",
      },
    ],
    name: "allowanceBip32X",
    inputs: [
      {
        type: "address",
        name: "_tokenOwner",
        internalType: "address",
      },
      {
        type: "address",
        name: "_spender",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "success",
        internalType: "bool",
      },
    ],
    name: "approve",
    inputs: [
      {
        type: "address",
        name: "_spender",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_tokens",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "success",
        internalType: "bool",
      },
    ],
    name: "approveBip32X",
    inputs: [
      {
        type: "address",
        name: "_spender",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_tokens",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    name: "balanceOf",
    inputs: [
      {
        type: "address",
        name: "_who",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "burnFrom",
    inputs: [
      {
        type: "address",
        name: "_account",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "burnFromBip32X",
    inputs: [
      {
        type: "address",
        name: "_account",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "byfrostOrigin",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint8",
        name: "_decimals",
        internalType: "uint8",
      },
    ],
    name: "decimals",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "emergencyResponder",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "balance",
        internalType: "uint256",
      },
    ],
    name: "getBalanceBip32X",
    inputs: [
      {
        type: "address",
        name: "_identifiedAddress",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "bip32X_type",
        internalType: "uint256",
      },
    ],
    name: "getBip32XTypeForContractAddress",
    inputs: [
      {
        type: "address",
        name: "_contractAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "result",
        internalType: "uint256",
      },
    ],
    name: "getIncorrectlySentAssetsBalance",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "result",
        internalType: "uint256",
      },
    ],
    name: "getNativeTokenType",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "getOnlyAcceptsKycInput",
    inputs: [
      {
        type: "address",
        name: "_identifiedAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "getOnlyAcceptsKycInputPermanently",
    inputs: [
      {
        type: "address",
        name: "_identifiedAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bytes32",
        name: "",
        internalType: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "getRoleMember",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
      {
        type: "uint256",
        name: "index",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    name: "getRoleMemberCount",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "result",
        internalType: "address",
      },
    ],
    name: "getShyftCacheGraphAddress",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "balance",
        internalType: "uint256",
      },
    ],
    name: "getTotalSupplyBip32X",
    inputs: [
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "grantRole",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "hasBeenUpdated",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "hasRole",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "kycSend",
    inputs: [
      {
        type: "address",
        name: "_identifiedAddress",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
      {
        type: "bool",
        name: "_requiredConsentFromAllParties",
        internalType: "bool",
      },
      {
        type: "bool",
        name: "_payForDirty",
        internalType: "bool",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "lockContractToOnlyAcceptsKycInputPermanently",
    inputs: [
      {
        type: "address",
        name: "_contractAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "machineConsentHelperAddress",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "migrateFromKycContract",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "mint",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "mintBip32X",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "string",
        name: "_name",
        internalType: "string",
      },
    ],
    name: "name",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "owner",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "removeOwner",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "renounceRole",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "responderRedeemIncorrectlySentAssets",
    inputs: [
      {
        type: "address",
        name: "_destination",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_amount",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "revokeRole",
    inputs: [
      {
        type: "bytes32",
        name: "role",
        internalType: "bytes32",
      },
      {
        type: "address",
        name: "account",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setAutoUpgrade",
    inputs: [
      {
        type: "bool",
        name: "_autoUpgrade",
        internalType: "bool",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "setByfrostNetwork",
    inputs: [
      {
        type: "uint256",
        name: "_tokenAmount",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
      {
        type: "address",
        name: "_distributionContract",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "setByfrostOrigin",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "setLockOnlyAcceptsKycInputPermanently",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "setMachineConsentHelperAddress",
    inputs: [
      {
        type: "address",
        name: "_machineConsentHelperAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "setOnlyAcceptsKycInput",
    inputs: [
      {
        type: "bool",
        name: "_onlyAcceptsKycInputValue",
        internalType: "bool",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "setPrimaryNetwork",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "setShyftCacheGraphAddress",
    inputs: [
      {
        type: "address",
        name: "_shyftCacheGraphAddress",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "setShyftKycContractRegistryAddress",
    inputs: [
      {
        type: "address",
        name: "_addr",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint8",
        name: "result",
        internalType: "uint8",
      },
    ],
    name: "setV1EmergencyErc20RedemptionResponder",
    inputs: [
      {
        type: "address",
        name: "_emergencyResponder",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "shyftCacheGraphAddress",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "shyftKycContractRegistryAddress",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "string",
        name: "_symbol",
        internalType: "string",
      },
    ],
    name: "symbol",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "tokenFallback",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
      {
        type: "bytes",
        name: "_data",
        internalType: "bytes",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "result",
        internalType: "uint256",
      },
    ],
    name: "totalSupply",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "transfer",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "result",
        internalType: "bool",
      },
    ],
    name: "transferBip32X",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "success",
        internalType: "bool",
      },
    ],
    name: "transferFrom",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_tokens",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "success",
        internalType: "bool",
      },
    ],
    name: "transferFromBip32X",
    inputs: [
      {
        type: "address",
        name: "_from",
        internalType: "address",
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_tokens",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_bip32X_type",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "transferFromErc20TokenToBip32X",
    inputs: [
      {
        type: "address",
        name: "_erc20ContractAddress",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    name: "updateContract",
    inputs: [
      {
        type: "address",
        name: "_addr",
        internalType: "address",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    name: "updatedShyftKycContractAddress",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "result",
        internalType: "uint256",
      },
    ],
    name: "upgradeNativeTokens",
    inputs: [
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    name: "v1TotalUpgradeAmount",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    name: "withdrawAllNative",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address payable",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "withdrawNative",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address payable",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "withdrawToExternalContract",
    inputs: [
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_gasAmount",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "withdrawToShyftKycContract",
    inputs: [
      {
        type: "address",
        name: "_shyftKycContractAddress",
        internalType: "address",
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "bool",
        name: "ok",
        internalType: "bool",
      },
    ],
    name: "withdrawTokenBip32XToErc20",
    inputs: [
      {
        type: "address",
        name: "_erc20ContractAddress",
        internalType: "address",
      },
      {
        type: "address",
        name: "_to",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "_value",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "receive",
    stateMutability: "payable",
  },
];
